import AxiosRestService from '@gms/network/src/axiosRestService';
import parseJsonApiResponse from '@/api/jsonapi/ResponseParser';

// At the beginning the following buttons will be selected
const FILTERS = ['active', 'future']

const initialState = () => ({
  index: [],
  loading: false,
  errorLoadingIndex: false,
  filter: FILTERS,
  isPersonal: false,
  itemsPerPage: 15,
  numberOfItems: 0,
  page: 1,
  sortBy: ['start'],
  sortDesc: [true],
})

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: initialState(),
  // -----------------------------------------------------------------
  getters: {
    index: (state) => state.index,
    loading: (state) => state.loading,
    errorLoadingIndex: (state) => state.errorLoadingIndex,
    errorDownloadingInvoice: (state) => state.errorDownloadingInvoice,
    filter: (state) => state.filter,
    isPersonal: (state) => state.isPersonal,
    itemsPerPage: (state) => state.itemsPerPage,
    numberOfItems: (state) => state.numberOfItems,
    page: (state) => state.page,
    sortBy: (state) => state.sortBy,
    sortDesc: (state) => state.sortDesc,
    sortUrlEncoded: (state) => state.sortBy
      .map((field, index) => (state.sortDesc[index] ? `-${field}` : field))
      .join(','),
  },
  // -----------------------------------------------------------------
  mutations: {
    setIndex: (state, roles) => { state.index = roles },
    setLoading: (state, loading) => { state.loading = loading },
    setErrorLoadingIndex: (state, errorLoadingIndex) => {
      state.errorLoadingIndex = errorLoadingIndex
    },
    setErrorDownloadingInvoice: (state, errorDownloadingInvoice) => {
      state.errorDownloadingInvoice = errorDownloadingInvoice
    },
    setFilter: (state, filter) => { state.filter = filter },
    setIsPersonal: (state, isPersonal) => { state.isPersonal = isPersonal },
    reset(state) {
      const newState = initialState()
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key]
      })
    },
    setNumberOfItems: (state, numberOfItems) => { state.numberOfItems = numberOfItems },
    setItemsPerPage: (state, itemsPerPage) => { state.itemsPerPage = itemsPerPage },
    setPage: (state, page) => { state.page = page },
    setSortBy: (state, sortBy) => { state.sortBy = sortBy },
    setSortDesc: (state, sortDesc) => { state.sortDesc = sortDesc },
  },
  // -----------------------------------------------------------------
  actions: {
    loadIndex: async (context) => {
      context.commit('setLoading', true)
      const headers = { Accept: 'application/vnd.api+json' }
      const params = {
        include: 'Devices,Sites.Locations,Sites.Zones,Users.BlockedUsers,MaintenancePeriods',
        'filter[timespan]': context.state.filter.join(','),
        limit: context.state.itemsPerPage,
        page: context.state.page,
        sort: context.getters.sortUrlEncoded,
      }
      if (context.state.filter === 'cancelled') {
        params['filter[state]'] = 'STORNO'
      }
      const url = context.state.isPersonal ? '/users/me/reservations' : '/reservations';
      AxiosRestService.get(url, { headers, params })
        .then((response) => {
          const reservations = parseJsonApiResponse(response);
          // reservations[0] = response;
          context.commit('setIndex', reservations);
          context.commit('setNumberOfItems', response.data.meta.record_count);
          context.commit('setErrorLoadingIndex', false)
        })
        .catch(() => context.commit('setErrorLoadingIndex', true))
        .finally(() => context.commit('setLoading', false))
    },
    filter: (context, filter) => {
      context.commit('setFilter', filter)
      context.dispatch('loadIndex')
    },
    setIsPersonal: (context, isPersonal) => {
      context.commit('setIsPersonal', isPersonal)
      context.dispatch('loadIndex')
    },
    downloadInvoice: (context, transaction) => AxiosRestService
      .get(`/transactions/getReportFor/${transaction.id}`)
      .then((response) => {
        context.commit('setErrorDownloadingInvoice', false)
        const link = document.createElement('a')
        link.href = `${process.env.VUE_APP_API_BASE_URL}/transactions/getReportFor/${transaction.id}`
        document.body.appendChild(link)
        link.click()
      })
      .catch(() => {
        context.commit('setErrorDownloadingInvoice', true)
      })
      .finally(() => {
        context.commit('setLoading', false)
      }),
    updateOptions: async (
      context,
      options,
    ) => {
      context.commit('setPage', options.page)
      context.commit('setItemsPerPage', options.itemsPerPage)
      context.commit('setSortBy', options.sortBy)
      context.commit('setSortDesc', options.sortDesc)
      await context.dispatch('loadIndex');
    },
  },
}
